// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"Menu_menuWrapper__AK799","menu":"Menu_menu__X8wsU"};